import React from "react";
import { Button, Plus } from "@opendate-app/setlist";

const formatPrice = (price) => {
  const value = Number(price);
  if (!value) return "FREE";
  return `$${value.toFixed(2)}`;
};

const templateTicketTypes = (template) =>
  template.ticketTypes.length > 0 ? template.ticketTypes : ((template.config || {}).ticketTypes || []);

const counted = (rows, one, many) => (rows && rows.length ? [`${rows.length} ${rows.length === 1 ? one : many}`] : []);

const templateIncludes = ({ config }) =>
  config
    ? [
        ...counted(config.addOns, "add-on", "add-ons"),
        ...counted(config.holds, "hold", "holds"),
        ...counted(config.kills, "kill", "kills"),
        ...counted(config.promoCodes, "promo code", "promo codes"),
      ].join(" · ")
    : "";

const TemplateGrid = ({ templates, showType, showTypeCount, onApply, onApplyToAll }) => (
  <div className="series-template-grid">
    {templates.map((template) => (
      <div key={template.id} className="series-template-card">
        <div className="series-template-card-name">{template.name}</div>
        <div className="series-template-card-description">{template.description}</div>
        <div className="series-template-card-tags">
          {templateTicketTypes(template).map((type) => (
            <span key={String(type.name)} className="series-template-tag">
              {String(type.name)} · {formatPrice(type.price)}
            </span>
          ))}
        </div>
        {templateIncludes(template) && (
          <div className="series-template-card-includes">Includes {templateIncludes(template)}</div>
        )}
        <div className="series-template-card-actions">
          <Button variant="primary" size="sm" onClick={() => onApply(template)}>
            {showTypeCount > 1 ? `Apply to ${showType}` : "Use Template"}
          </Button>
          {showTypeCount > 1 && onApplyToAll && (
            <Button variant="link-gray" size="sm" onClick={() => onApplyToAll(template)}>
              Apply to all show types
            </Button>
          )}
        </div>
      </div>
    ))}
  </div>
);

const TicketTemplatePicker = ({
  templates,
  showType,
  showTypeCount,
  copyableShowTypes,
  onApply,
  onApplyToAll,
  onCopyFrom,
  onStartFromScratch,
}) => {
  const starters = templates.filter((template) => template.starter);
  const saved = templates.filter((template) => !template.starter);

  return (
    <div className={`series-templates${showTypeCount > 1 ? " series-templates-below-tabs" : ""}`}>
      <h3 className="series-templates-title">
        {showTypeCount > 1 ? `Set up \u201C${showType}\u201D tickets` : "Quick start with a template"}
      </h3>
      <p className="series-edit-section-subtitle">
        Pick a template to pre-fill ticket types, or start from scratch. You can customize everything
        after.
      </p>

      {starters.length > 0 && (
        <>
          <div className="series-templates-group">
            Starter templates <span className="series-templates-group-meta">Provided by Opendate</span>
          </div>
          <TemplateGrid
            templates={starters}
            showType={showType}
            showTypeCount={showTypeCount}
            onApply={onApply}
            onApplyToAll={onApplyToAll}
          />
        </>
      )}

      {saved.length > 0 && (
        <>
          <div className="series-templates-group">Your saved templates</div>
          <TemplateGrid
            templates={saved}
            showType={showType}
            showTypeCount={showTypeCount}
            onApply={onApply}
            onApplyToAll={onApplyToAll}
          />
        </>
      )}

      <div className="series-templates-footer">
        <Button variant="link-gray" icon={Plus} onClick={onStartFromScratch}>
          Start from scratch
        </Button>
        {copyableShowTypes.map((other) => (
          <Button key={other} variant="link-gray" size="sm" onClick={() => onCopyFrom(other)}>
            Copy from {other}
          </Button>
        ))}
      </div>
    </div>
  );
};

export default TicketTemplatePicker;
